import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";

interface RelatedComicsProps {
  currentId: string;
  genres: string[];
}

export default function RelatedComics({ currentId, genres }: RelatedComicsProps) {
  const related = comics
    .filter((comic) => comic.id !== currentId && comic.genres.some((genre) => genres.includes(genre)))
    .sort((a, b) => b.views - a.views)
    .slice(0, 4);

  if (related.length === 0) return null;

  return (
    <section className="w-full">
      <div className="flex items-center justify-between mb-5">
        <h2 className="font-heading font-bold text-lg text-foreground-950 flex items-center gap-2">
          <i className="ri-magic-line text-accent-500" />
          相关推荐
        </h2>
        <span className="text-xs text-foreground-500">根据同题材智能推荐</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {related.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}